import React, { createContext, useContext } from 'react';

const AdminAccessContext = createContext({ loading: true, fullAccess: false, permissions: [], sections: [] });
export const AdminAccessProvider = AdminAccessContext.Provider;
export const useAdminAccess = () => useContext(AdminAccessContext);
export const canAdmin = (access, permission) => Boolean(access?.fullAccess || access?.permissions?.includes('all') || access?.permissions?.includes(permission));
